import { render, staticRenderFns } from "./configSettingsChart.vue?vue&type=template&id=301d97d4"
import script from "./configSettingsChart.vue?vue&type=script&lang=js"
export * from "./configSettingsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports